import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseApiTemplateService, Core2Config } from "../shared";
import { InnovatifUserHdrContainerModel } from "../../../../../models/aggregates/innovatif-user";
 


@Injectable({ providedIn: 'root' })
export class InnovatifUserHdrService extends BaseApiTemplateService<InnovatifUserHdrContainerModel> {

    static readonly INNOVATIF_USER_HDR_SUBPATH = 'innovatif-ekyc/user-headers/';

    constructor(http: HttpClient) {
        super();
        this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.TPY_PREFIX + InnovatifUserHdrService.INNOVATIF_USER_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.TPY_PREFIX + InnovatifUserHdrService.INNOVATIF_USER_HDR_SUBPATH + BaseApiTemplateService.BACKOFFICE_EP;
        this.httpClient = http;
    }
}